import {
  GET_TRANSPORT_REPORT,
  GET_TRANSPORT_REPORT_REQUEST,
  GET_TRANSPORT_REPORT_SUCCESS,
  GET_TRANSPORT_REPORT_FAILURE,
 TRANSPORT_REPORT_RESET,
} from "./constant"

export const getTransportReport = payload => ({
  type: GET_TRANSPORT_REPORT,
  payload,
})

export const getTransportReportRequest = () => ({
  type: GET_TRANSPORT_REPORT_REQUEST,
})

export const getTransportReportSuccess = payload => ({
  type: GET_TRANSPORT_REPORT_SUCCESS,
  payload,
})

export const getTransportReportFailure = error => ({
  type: GET_TRANSPORT_REPORT_FAILURE,
  payload: error,
})

export const transportReportReset = () => ({
  type: TRANSPORT_REPORT_RESET,
})